var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewnext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 25C8 15.6 15.6 8 25 8C34.4 8 42 15.6 42 25C42 34.4 34.4 42 25 42C15.6 42 8 34.4 8 25ZM40 25C40 16.7 33.3 10 25 10C16.7 10 10 16.7 10 25C10 33.3 16.7 40 25 40C33.3 40 40 33.3 40 25Z",
    fill: "#E10006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2999 33.2998L31.5999 24.9998L23.2999 16.6998L24.6999 15.2998L34.3999 24.9998L24.6999 34.6998L23.2999 33.2998Z",
    fill: "#E10006"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 24L33 26L16 26L16 24L33 24Z",
    fill: "#E10006"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewnext);
export default __webpack_public_path__ + "static/media/viewnext.da5fe2a0194e20fc3fc8782a8d6e286c.svg";
export { ForwardRef as ReactComponent };